var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroductoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F8B01F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9043 21.1L11.2543 23.9C11.121 23.9833 10.9793 24.0208 10.8293 24.0125C10.6793 24.0042 10.546 23.9583 10.4293 23.875C10.3126 23.7917 10.2251 23.6833 10.1668 23.55C10.1085 23.4167 10.096 23.2667 10.1293 23.1L11.3543 17.8L7.2543 14.225C7.12097 14.1083 7.0418 13.9792 7.0168 13.8375C6.9918 13.6958 6.99597 13.5583 7.0293 13.425C7.06264 13.2917 7.13764 13.1792 7.2543 13.0875C7.37097 12.9958 7.51264 12.9417 7.6793 12.925L13.1043 12.45L15.2043 7.45C15.271 7.3 15.371 7.1875 15.5043 7.1125C15.6376 7.0375 15.771 7 15.9043 7C16.0376 7 16.171 7.0375 16.3043 7.1125C16.4376 7.1875 16.5376 7.3 16.6043 7.45L18.7043 12.45L24.1293 12.925C24.296 12.9417 24.4376 12.9958 24.5543 13.0875C24.671 13.1792 24.746 13.2917 24.7793 13.425C24.8126 13.5583 24.8168 13.6958 24.7918 13.8375C24.7668 13.9792 24.6876 14.1083 24.5543 14.225L20.4543 17.8L21.6793 23.1C21.7126 23.2667 21.7001 23.4167 21.6418 23.55C21.5835 23.6833 21.496 23.7917 21.3793 23.875C21.2626 23.9583 21.1293 24.0042 20.9793 24.0125C20.8293 24.0208 20.6876 23.9833 20.5543 23.9L15.9043 21.1Z",
    fill: "#1A1464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroductoryIcon);
export default __webpack_public_path__ + "static/media/IntroductoryIcon.8db6e186eb09d11f9654703edc25f6d7.svg";
export { ForwardRef as ReactComponent };